module.exports = __webpack_public_path__ + "i/80d417dbd4337ae67e2af184759b5d2a.png";